
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/who-we-are",
      function () {
        return require("private-next-pages/about-us/who-we-are.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/who-we-are"])
      });
    }
  